const activeSortOption = document.querySelector('.gr-custom-facet__active-sortby');
const sortInput = document.querySelectorAll('.oj-custom-facet__sort-by-desktop input');
sortInput.forEach((e) => {
	if (e.hasAttribute('checked')) {
		activeSortOption.innerHTML = e.parentNode.innerText;
	}
})
function gridSwitch() {
	const collection = document.querySelector('#ProductGridContainer > div');
	const oneGrid = document.getElementById('oj-plp__grid--1');
	const twoGrid = document.getElementById('oj-plp__grid--2');

	oneGrid.addEventListener('click', function () {
		collection.classList.add('oj-grid--1')
		oneGrid.classList.add('active')
		collection.classList.remove('oj-grid--2')
		twoGrid.classList.remove('active')
	})
	twoGrid.addEventListener('click', function () {
		collection.classList.add('oj-grid--2')
		twoGrid.classList.add('active')
		collection.classList.remove('oj-grid--1')
		oneGrid.classList.remove('active')
	})
	if (oneGrid.classList.contains('active')) {
		collection.classList.add('oj-grid--1')
		collection.classList.remove('oj-grid--2')

	} else {
		collection.classList.add('oj-grid--2')

	}
}
document.addEventListener('click', function (event) {
	setTimeout(() => {
		const activeSortOption = document.querySelector('.gr-custom-facet__active-sortby');

		const sortInput = document.querySelectorAll('.oj-custom-facet__sort-by-desktop input');

		sortInput.forEach((e) => {
			if (e.hasAttribute('checked')) {
				activeSortOption.innerHTML = e.parentNode.innerText;
			}
		})
	}, 3000)

	const sortOptions = document.querySelector('.oj-custom-facet__sort-by-desktop')
	if (event.target.matches('.oj-custom-facet__sort-by-desktop, .gr-custom-facet__active-sortby, .custom-select, .custom-facet-filters__sort .oj-text__regular')) {
		if (event.target.matches('.custom-facet-filters__sort, .custom-facet-filters__sort .oj-text__regular')) {
			sortOptions.classList.add('active')
		} else {
			sortOptions.classList.toggle('active')
		}
	} else {
		sortOptions.classList.remove('active')
	}
	gridSwitch();
})